import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import ToolbarIconButton from './ToolbarIconButton';
import { useCallback, useRef } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarChildActionDropdown = ({
  icon: ParentActionIcon,
  active: isToolbarActive,
  childActions,
  // handle freezing / thawing hover controls
  onDropdownOpenChange
}) => {
  const buttonRef = useRef(null);
  const handleOpenChange = useCallback(evt => {
    if (evt.target.value === true) {
      var _buttonRef$current;
      (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }
    onDropdownOpenChange(evt.target.value);
  }, [onDropdownOpenChange]);
  return /*#__PURE__*/_jsx(Dropdown, {
    placement: "bottom right",
    closeOnOutsideClick: true,
    buttonRef: buttonRef,
    onOpenChange: handleOpenChange,
    arrowSize: "small"
    // eslint-disable-next-line hubspot-dev/no-inline-component-props
    ,
    Button: props => /*#__PURE__*/_jsx(ToolbarIconButton, Object.assign({}, props, {
      icon: ParentActionIcon,
      use: "edge",
      isToolbarActive: isToolbarActive
    })),
    children: /*#__PURE__*/_jsx(List, {
      wrapChildren: true,
      children: childActions.map(({
        id,
        callback,
        menuLabel,
        tooltipLabel,
        disabled
      }) => {
        if (tooltipLabel) {
          return /*#__PURE__*/_jsx(Tooltip, {
            title: tooltipLabel,
            placement: "right",
            children: /*#__PURE__*/_jsx(Button, {
              disabled: disabled,
              onClick: callback,
              children: menuLabel
            }, id)
          }, id);
        } else {
          return /*#__PURE__*/_jsx(Button, {
            disabled: disabled,
            onClick: callback,
            children: menuLabel
          }, id);
        }
      })
    })
  });
};
const ToolbarActionButtons = ({
  buttonActions,
  hasDropdown,
  active,
  lastButtonRounding,
  iconUse,
  rotateActionIcons,
  isTrellisTheme,
  variant,
  onDropdownOpenChange
}) => {
  return buttonActions.map(({
    id: actionId,
    callback,
    icon: ActionIcon,
    tooltipLabel,
    disabled,
    placement,
    autoPlacement,
    ariaLabel,
    childActions
  }, i) => {
    const isLastButton = i === buttonActions.length - 1;
    const cornerToRound = !hasDropdown && isLastButton ? lastButtonRounding : undefined;
    if (childActions && childActions.length > 0) {
      return /*#__PURE__*/_jsx(ToolbarChildActionDropdown, {
        icon: ActionIcon,
        active: active,
        childActions: childActions,
        onDropdownOpenChange: onDropdownOpenChange
      }, actionId);
    }
    return /*#__PURE__*/_jsx(ToolbarIconButton, {
      borderInlineEndWidth: !hasDropdown && isLastButton ? '100' : '0',
      icon: ActionIcon,
      use: iconUse,
      isToolbarActive: active,
      disabled: disabled,
      onClick: disabled ? undefined : callback,
      placement: placement,
      autoPlacement: autoPlacement,
      cornerToRound: cornerToRound,
      tooltip: tooltipLabel,
      rotate: rotateActionIcons,
      isTrellisTheme: isTrellisTheme,
      "aria-label": ariaLabel,
      variant: variant === 'aiEditor' ? 'aiEditor' : 'default'
    }, actionId);
  });
};
export default ToolbarActionButtons;